import { CircularProgress } from '@mui/material';
import './loader.scss';

const Loader = () => {
    return(
        <div className='loader'><CircularProgress color="inherit" /></div>
    )
}
export default Loader;